"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginCallbackController = void 0;
var auth_status_1 = require("@jawbreaker/auth-status");
var rum_cloudwatch_1 = require("@jawbreaker/rum-cloudwatch");
var js_cookie_1 = __importDefault(require("js-cookie"));
var createServerCookie_1 = require("./Cookies/createServerCookie");
var JWTHelper_1 = require("./JWTHelper");
var Parser_1 = require("./Parser");
var PipResponseValidator_1 = require("./PipResponseValidator");
var StatusHelper_1 = require("./StatusHelper");
var StatusManager_1 = require("./StatusManager");
var TokenValidator_1 = require("./TokenValidator");
var pipResponseValidator = new PipResponseValidator_1.PipResponseValidator(new TokenValidator_1.TokenValidator(auth_status_1.Status.idTokenDecoder.decode));
var LoginCallbackController = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function LoginCallbackController(projectName, tokensFetcher, loginCbUrl) {
        this.projectName = projectName;
        this.tokensFetcher = tokensFetcher;
        this.loginCbUrl = loginCbUrl;
    }
    LoginCallbackController.prototype.getResponseDetails = function (query, codeVerifier, nonce, authorization) {
        return __awaiter(this, void 0, void 0, function () {
            var loginLogger, parsedState, parsedCode, parsedError, securityCookies, _a, referrer, feedback, tokensResult, pipResponseValidation, _b, data, accessToken, uitToken, expResultInSec, statusHelper, statusManager, status, today, isVtmGoPlus;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        loginLogger = new rum_cloudwatch_1.LoginLogger();
                        parsedState = (0, Parser_1.parseStateFromQuery)(query);
                        parsedCode = (0, Parser_1.parseCodeFromQuery)(query);
                        parsedError = (0, Parser_1.parseErrorFromQuery)(query);
                        securityCookies = [
                            (0, createServerCookie_1.createEmptyCookie)("vtmCodeVerifier"),
                            (0, createServerCookie_1.createEmptyCookie)("vtmNonce"),
                        ];
                        if (!parsedState.isValid) {
                            loginLogger.errorWithData("".concat(this.projectName, ": invalid state"), "INVALID_STATE");
                            return [2 /*return*/, {
                                    redirectUrl: "/",
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut("INVALID_STATE", false)))
                                    ], securityCookies, true),
                                }];
                        }
                        _a = parsedState.payload, referrer = _a.referrer, feedback = _a.feedback;
                        if (parsedError.isValid) {
                            loginLogger.errorWithData("".concat(this.projectName, ": parsed pip error"), parsedError.payload);
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut("PIP_ERROR", feedback)))
                                    ], securityCookies, true),
                                }];
                        }
                        if (!parsedCode.isValid) {
                            loginLogger.errorWithData("".concat(this.projectName, ": invalid code"), "INVALID_CODE");
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut("INVALID_CODE", feedback)))
                                    ], securityCookies, true),
                                }];
                        }
                        if (codeVerifier === undefined) {
                            loginLogger.basicError("".concat(this.projectName, ": no code-verifier data"));
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut("MISSING_CODEVERIFIER", feedback)))
                                    ], securityCookies, true),
                                }];
                        }
                        if (nonce === undefined) {
                            loginLogger.basicError("".concat(this.projectName, ": no nonce data"));
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut("MISSING_NONCE", feedback)))
                                    ], securityCookies, true),
                                }];
                        }
                        return [4 /*yield*/, this.tokensFetcher.get({
                                code: parsedCode.payload,
                                codeVerifier: codeVerifier,
                                loginCbUrl: this.loginCbUrl,
                                authorization: authorization,
                            })];
                    case 1:
                        tokensResult = _c.sent();
                        if (!tokensResult.isValid) {
                            loginLogger.errorWithData("".concat(this.projectName, ": tokenFetch error"), tokensResult.reason);
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut(tokensResult.reason, feedback)))
                                    ], securityCookies, true),
                                }];
                        }
                        pipResponseValidation = pipResponseValidator.validate(tokensResult.payload.tokensResponse);
                        if (!pipResponseValidation.isValid) {
                            loginLogger.errorWithData("".concat(this.projectName, ": pip-response error"), pipResponseValidation.reason);
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut(pipResponseValidation.reason, feedback)))
                                    ], securityCookies, true),
                                }];
                        }
                        _b = pipResponseValidation.payload, data = _b.data, accessToken = _b.accessToken, uitToken = _b.uitToken;
                        if (data.nonce !== nonce) {
                            loginLogger.basicError("".concat(this.projectName, ": nonce validation error"));
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut("INVALID_NONCE", feedback)))
                                    ], securityCookies, true),
                                }];
                        }
                        expResultInSec = (0, JWTHelper_1.extractExpInSeconds)(accessToken);
                        if (!expResultInSec.isValid) {
                            loginLogger.errorWithData("".concat(this.projectName, ": wrong exp data"), expResultInSec.reason);
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedOut(expResultInSec.reason, feedback)))
                                    ], securityCookies, true),
                                }];
                        }
                        statusHelper = new StatusHelper_1.StatusHelper(undefined);
                        statusManager = new StatusManager_1.StatusManager(statusHelper);
                        return [4 /*yield*/, statusManager.load(js_cookie_1.default.get("vtmAuthState"))];
                    case 2:
                        status = _c.sent();
                        today = new Date();
                        isVtmGoPlus = pipResponseValidation.payload.isVtmGoPlus;
                        if (auth_status_1.Status.isPending(status)) {
                            return [2 /*return*/, {
                                    redirectUrl: referrer,
                                    cookies: __spreadArray([
                                        (0, createServerCookie_1.createHttpOnlyServerCookie)(tokensResult.payload.refreshTokenCookie[0], tokensResult.payload.refreshTokenCookie[1], new Date(today.setMonth(today.getMonth() + 6))),
                                        (0, createServerCookie_1.createEmptyCookie)("isPlusUser"),
                                        (0, createServerCookie_1.createEmptyCookie)("dpg-component-at"),
                                        (0, createServerCookie_1.createEmptyCookie)("dpg-component-uit"),
                                        (0, createServerCookie_1.createEmptyCookie)("3th-party-name")
                                    ], securityCookies, true),
                                }];
                        }
                        return [2 /*return*/, {
                                redirectUrl: referrer,
                                cookies: __spreadArray([
                                    (0, createServerCookie_1.createHttpOnlyServerCookie)(tokensResult.payload.refreshTokenCookie[0], tokensResult.payload.refreshTokenCookie[1], new Date(today.setMonth(today.getMonth() + 6))),
                                    (0, createServerCookie_1.createServerCookie)("isPlusUser", isVtmGoPlus.toString(), new Date(today.setMonth(today.getMonth() + 6))),
                                    (0, createServerCookie_1.createServerCookie)("vtmAuthState", (0, JWTHelper_1.serialize)(auth_status_1.Status.loggedIn({
                                        sub: data.sub,
                                        email: data.email,
                                        exp: expResultInSec.payload,
                                        given_name: data.given_name,
                                        family_name: data.family_name,
                                    })), 
                                    // new Date(expResultInSec.right * 1000) ?? We put the exp date later for refreshflow in statusManager
                                    new Date(today.setMonth(today.getMonth() + 6))),
                                    (0, createServerCookie_1.createHttpOnlyServerCookie)("dpg-component-at", accessToken, new Date(today.setFullYear(today.getFullYear() + 1))),
                                    (0, createServerCookie_1.createHttpOnlyServerCookie)("dpg-component-uit", uitToken, new Date(today.setFullYear(today.getFullYear() + 1))),
                                    (0, createServerCookie_1.createHttpOnlyServerCookie)("3th-party-name", JSON.stringify({
                                        name: auth_status_1.Status.getGreeting(data).short,
                                    }), new Date(expResultInSec.payload * 1000))
                                ], securityCookies, true),
                            }];
                }
            });
        });
    };
    return LoginCallbackController;
}());
exports.LoginCallbackController = LoginCallbackController;
